import { Table } from "react-bootstrap";
import ContactRow from "./ContactRow";

export default function ContactTable({ contacts, selected, onToggle, onDelete }) {
  return (
    <div className="contacts-table-shell">
      <Table hover responsive className="contacts-table align-middle">
        <thead>
          <tr>
            <th className="contacts-table-check"></th>
            <th>Name</th>
            <th>Phone</th>
            <th className="contacts-table-actions"></th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => (
            <ContactRow
              key={contact.id}
              contact={contact}
              selected={selected.includes(contact.id)}
              onToggle={onToggle}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </Table>
    </div>
  );
}
